import { Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { numbersValidator } from '../form/mng-form-validators';

export const VORWAHL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MngVorwahlFieldDirective),
  multi: true
};

export const VORWAHL_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => MngVorwahlFieldDirective),
  multi: true
};

@Directive({
  selector: '[mngVorwahlField]',
  providers: [VORWAHL_VALUE_ACCESSOR, VORWAHL_VALIDATOR]
})
export class MngVorwahlFieldDirective implements ControlValueAccessor, Validator {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  @HostListener('change', ['$event.target.value']) onChange = (value: any) => {
    return;
  };

  @HostListener('blur', []) onTouched = () => {
    return;
  };

  @HostListener('input', ['$event.target.value']) onInput = this.onChange;

  /**
   * Wert --> HTML Element
   */
  writeValue(value: string) {
    // MODEL -> VIEW
    if (value) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
    }
  }

  registerOnChange(fn: (_: any) => void) {
    // VIEW -> MODEL
    this.onChange = (value) => {
      fn(removeLeadingZerosAndTrim(value));
    };
    this.onInput = this.onChange;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  validate(c: FormControl<string>): ValidationErrors | null {
    return numbersValidator(c);
  }
}

/**
 * Entfernt alle führenden Nullen.
 *
 *
 * @param value "Numeric" string
 * @return A string with removed leading zeros
 */
export function removeLeadingZerosAndTrim(value: string): string {
  return value.trim().replace(new RegExp('^0*'), '');
}

// TODO: find dups and extract to validation-helper
